import React from 'react';

import { Checkbox } from '@components/common';

import { uuid } from '@utils/common';

import styles from '../Table.module.scss';

const SelectColumnCell = (props: any) => {
	const {
		row,
		table: {
			getState,
		},
	} = props;

	const { rowSelection: selectedRowIds } = getState();

	const isDisabled = row?.original?.isSelectRowDisabled;
	const checked = row.getIsSelected();
	const indeterminate = row.getIsSomeSelected();

	const isParentCheckbox = !!row?.original?.subRows;
	const countOfChildren = row?.original?.subRows?.length;
	const countOfCheckedChildren = Object.keys(selectedRowIds)
		?.filter(key => key.startsWith(`${row.id}.`)).length;
	const isCheckedAllChildren = (countOfCheckedChildren === countOfChildren)
		&& !!countOfCheckedChildren;

	const isChecked = isParentCheckbox ? isCheckedAllChildren : checked;
	const isIndeterminate = isParentCheckbox
		? !isChecked && !!countOfCheckedChildren
		: indeterminate;

	const onChangeForTable = row.getToggleSelectedHandler();

	return (
		<div className={styles.checkbox}>
			<Checkbox
				checked={isChecked}
				disabled={isDisabled}
				isFilledStyle
				isIndefinite={isIndeterminate}
				name={`checkbox-${row.id}-${uuid()}`}
				onChangeForTable={onChangeForTable}
			/>
		</div>
	);
};

export default SelectColumnCell;
